import React from 'react';
import { ReactComponent as DownloadIcon } from "../../styles/icon/download.svg";
import { ReactComponent as DeleteIcon } from "../../styles/icon/delete.svg";
import Button from "../../elements/Button/Button";
import styles from './CertificateItem.module.scss';
import strings from '../../lang/lang';

const CertificateItem = (props) => {
  const {
    date,
    onClick,
    onRevoke,
    status,
    isExistBtn
  } = props;
  return (
    <div className={styles.certificate_item}>
      <div className={styles.certificate_row}>
        <div className={styles.certificate_label}>{strings.certificateItem.text.generatedOn}</div>
        <div className={styles.certificate_label}/>
        <div className={styles.certificate_value}>{date}</div>
      </div>
      <div className={styles.certificate_row}>
        <p className={styles.certificate_label}>{strings.certificateItem.text.status}</p>
        <p className={styles.certificate_label}/>
        <p className={styles.certificate_value}>{status}</p>
      </div>
      {isExistBtn && (
        <div className={styles.certificate_btn}>
          <Button
            name={strings.certificateItem.buttons.download}
            variant="primary"
            secondaryClassName="lg"
            onClick={onClick}
          >  
            <DownloadIcon /> 
          </Button>
            <div className={styles.certificate_btn_secondary}>
                <Button
                    name={strings.certificateItem.buttons.revoke}
                    variant="secondary"
                    className="revoke"
                    secondaryClassName="lg"

                    onClick={onRevoke}
                >
                    <DeleteIcon/>
                </Button>
            </div>
        </div>
      )}
    </div>
  );
};

export default CertificateItem;
